export default __webpack_public_path__ + "static/phoneMobile1-e4045ccb5bab0387eab16aa11d2f2b90.png";